import { Injectable } from '@angular/core';
import { IApplicationConfig } from '../../_models/ApplicationConfig';
import config from '@arcgis/core/config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  static appConfig: IApplicationConfig;

  constructor() {}

  static loadConfig(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch('assets/config.json');
        ConfigService.appConfig = await response.json();
        config.portalUrl = ConfigService.appConfig.portalUrl;
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  get Config(): IApplicationConfig {
    return ConfigService.appConfig;
  }
}
